define('plugin/invoice/view/InvoiceListItemView',['require','lib/view/LayoutView','Config'],function (require) {

    var LayoutView = require('lib/view/LayoutView');
    var Config = require('Config');

    /**
     * Invoice item view
     *
     * @class InvoiceListItemView
     */
    return LayoutView.extend({

        template: '#invoice_list_item_view',

        serializeData: function () {
            return _.extend(
                LayoutView.prototype.serializeData.apply(this), {
                    allow_print: Config.getInstance().isExternalLinkWithAuthAllowed() && this.model.isPrintAllowed()
                }
            );
        }

    });

});
